import { AxiosResponse } from 'axios'
import apiClient from 'api/common/common'
import { IndividualLicenseCheckType } from 'api/common/constants'
import { Status } from 'api/common/statuses'
import { IdentificationCompanyRegisterRequest, IdentificationIndividualRegisterRequest } from 'api/common/requests'
import { IdentificationCompanyRegisterResponse, IdentificationIndividualRegisterResponse } from 'api/common/responses'
import loginData from 'utilities/loginData'
import bpoData from 'utilities/bpoData'

/**
 * 個人契約の証明書登録API
 * @param request
 * @param callback
 */
export const identificationRegisterForIndividualAPI = async (
  request: IdentificationIndividualRegisterRequest, 
  callback: (result?: IndividualLicenseCheckType, shouldNavigateToBpo?: boolean, errorMessage?: string) => void
) => {
  const timestamp = new Date().toISOString()
  console.log(`[DEBUG ${timestamp}] identificationRegisterForIndividualAPI request:`, request)
  
  await apiClient
    .post('/identification/individual', request)
    .then((response: AxiosResponse<IdentificationIndividualRegisterResponse>) => {
      console.log(`[DEBUG ${timestamp}] identificationRegisterForIndividualAPI response:`, response)
      console.log(`[DEBUG ${timestamp}] response.headers:`, response.headers)
      console.log(`[DEBUG ${timestamp}] response.data:`, response.data)
      
      // 通常の処理
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      const result = response?.data?.result
      const success = status === Status.Success
      
      console.log(`[DEBUG ${timestamp}] status: ${status}`)
      console.log(`[DEBUG ${timestamp}] result: ${result}`)
      console.log(`[DEBUG ${timestamp}] success: ${success}`)
      console.log(`[DEBUG ${timestamp}] response.data.errors:`, (response?.data as any)?.errors)
      
      console.log(`[DEBUG ${timestamp}] About to check validateError. Status is: "${status}"`)
      
      // 新しいresultフィールドに基づくエラー処理
      // バックエンドが統一的にresultフィールドで状態を返すようになったため、
      // validateErrorの処理は不要（後方互換性のため残す）
      const errors = response?.headers['x-aqc-errors']
      if (status === Status.ValidateError && errors) {
        console.log(`[DEBUG ${timestamp}] Legacy validateError detected, but will use result field instead`)
      }
      
      if (success && response?.data?.contractStatus) {
        loginData.setContractStatus(response.data.contractStatus)
      }
      
      // BPO情報がある場合はセッションストレージに保存してフラグを立てる
      let shouldNavigateToBpo = false
      if (response?.data?.bpoInfo) {
        bpoData.setBpoRequestId(response.data.bpoInfo.requestId)
        bpoData.setBpoStatus(response.data.bpoInfo.status)
        
        // BPO用verificationIdも保存
        if (response.data.bpoInfo.bpoVerificationId) {
          bpoData.setItem('bpo_verification_id', response.data.bpoInfo.bpoVerificationId)
        }
        
        shouldNavigateToBpo = true
      }
      
      // TRUSTDOCK verificationIdを保存（BPO審査でポーリングに使用）
      if (request.verificationId) {
        bpoData.setItem('trustdock_verification_id', request.verificationId)
        console.log(`[DEBUG ${timestamp}] TRUSTDOCK verification ID saved: ${request.verificationId}`)
      }
      
      console.log(`[DEBUG ${timestamp}] Calling callback with result: ${result}, shouldNavigateToBpo: ${shouldNavigateToBpo}`)
      callback(result, shouldNavigateToBpo)
    })
    .catch((error) => {
      console.error(`[DEBUG ${timestamp}] identificationRegisterForIndividualAPI error:`, error)
      console.error(`[DEBUG ${timestamp}] error.response:`, error.response)
      console.error(`[DEBUG ${timestamp}] error.response.data:`, error.response?.data)
      console.error(`[DEBUG ${timestamp}] error.response.status:`, error.response?.status)
      
    })
}

/**
 * 法人契約の証明書登録API
 * @param request
 * @param callback
 */
export const identificationRegisterForCompanyAPI = async (request: IdentificationCompanyRegisterRequest, callback: (result: boolean) => void) => {
  await apiClient
    .post('/identification/company', request)
    .then((response: AxiosResponse<IdentificationCompanyRegisterResponse>) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      const apiResult = response?.data?.result ?? false
      const result = status === Status.Success && apiResult
      const contractStatus = response?.data?.contractStatus
      if (result && contractStatus != null) {
        loginData.setContractStatus(contractStatus)
      }
      callback(result)
    })
    .catch((error) => {
      console.error(error)
    })
}
